// TSS vite/04 §"Endpoint paths".
// Per-feature path helpers — keep URL knowledge local so a backend rename
// touches one file. Public channel (contract: public-client-channel.md).

export const profilePaths = {
    // GET/PATCH public/me — perfil del cliente (identidad, SIN sobre). El PATCH
    // edita solo name/phone; el resto se descarta server-side (stripUnknown).
    me: () => 'public/me',
    // POST public/me/password — cambio de clave logueado (Q-102). Sin UI aún.
    password: () => 'public/me/password',
};
